import React from 'react';
import styled from '@emotion/styled';
import dimensions from 'styles/dimensions';
import Content from 'components/_ui/Content';
import Tout from 'components/Tout';
import ContentBlock from 'components/ContentBlock';
import ContentColumns from 'components/ContentColumns';
import Accordion from 'components/Accordion';
import ContentList from 'components/ContentList';
import FeaturedCaseStudies from 'components/FeaturedCaseStudies';
import Trapdoor from 'components/Trapdoor';
import FeatureProducts from 'components/FeatureProducts';
import LuminousPlayer from './LuminousPlayer';
import CustomHTML from 'components/CustomHTML';
import Partners from 'components/Partners';
import GettingStarted from 'components/_page/product/GettingStarted';
import CondensedContactForm from 'components/CondensedContactForm';

const SliceZoneContainer = styled.div`
  > * + * {
    margin-top: 6.4rem;
  }
  
  &.is-spaced {
    padding-bottom: 8rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    &.is-spaced {
      padding-bottom: 10.4rem;
    }
  
    > * + * {
      margin-top: 10.4rem;
    }
  }
`;

const SliceContent = styled.div`
  & + * {
    margin-top: 6.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    & + * {
      margin-top: 10.4rem;
    }
  }
`;

const SliceZone = ({ body, allProducts, variant, uid, settings, hasForm, bottomSpacer }) => {
  return (
    <SliceZoneContainer className={`${variant ? `SliceZone--${variant}` : ''} ${bottomSpacer ? 'is-spaced' : ''}`}>
      {body.map((slice, i) => {
        switch(slice.type) {
          case 'text':
            return (
              <SliceContent>
                <Content
                  key={i}
                  content={slice.primary.content}
                />
              </SliceContent>
            );

          case 'tout':
            return (
              <Tout
                key={i}
                intro={slice.primary.intro}
                heading={slice.primary.heading}
                content={slice.primary.content}
              />
            );

          case 'content_block':
            return (
              <ContentBlock
                key={i}
                intro={slice.primary.intro}
                heading={slice.primary.heading}
                image={slice.primary.image}
                illustration={slice.primary.illustration}
                content={slice.primary.content}
              />
            );

          case 'content_columns':
            return (
              <ContentColumns
                key={i}
                items={slice.fields}
              />
            );

          case 'accordion':
            return (
              <Accordion
                key={i}
                intro={slice.primary.intro}
                heading={slice.primary.heading}
                image={slice.primary.image}
                illustration={slice.primary.illustration}
                content={slice.primary.content}
                items={slice.fields}
                buttonText={slice.primary.button_text}
                buttonDestination={slice.primary.button_destination}
              />
            );

          case 'content_list':
            return (
              <ContentList
                key={i}
                intro={slice.primary.intro}
                heading={slice.primary.heading}
                image={slice.primary.image}
                illustration={slice.primary.illustration}
                content={slice.primary.content}
                items={slice.fields}
                buttonText={slice.primary.button_text}
                buttonDestination={slice.primary.button_destination}
                variant={slice.primary.is_numbered && 'numbered'}
              />
            );

          case 'case_study':
            return (
              <FeaturedCaseStudies
                key={i}
                delay={slice.primary.case_study_delay || 6000}
                slides={slice.fields}
              />
            );

          case 'trapdoor':
            return (
              <Trapdoor
                key={i}
                intro={slice.primary.intro}
                heading={slice.primary.heading}
                buttonText={slice.primary.button_text}
                destination={slice.primary.destination}
                external={slice.primary.is_external}
              />
            );

          case 'product_suite':
            return (
              <FeatureProducts
                key={i}
                heading={slice.primary.heading || 'Better Together'}
                content={slice.primary.content || 'The Luminous Video Platform offers media companies four, data-powered video player products. Use one player or use them all simultaneously for better insights and results.'}
                products={slice.fields || allProducts.products_list}
                variant='landing'
              />
            );

          case 'player':
            return (
              <LuminousPlayer
                key={i}
                widget={slice.primary.widget_name || '0011r00002QWpLv_1624'}
                pubname={slice.primary.pubname || 'anyclipsitecom'}
                plid={slice.primary.plid}
              />
            );

          case 'partner_grid':
            return (
              <Partners partners={slice.fields} />
            );

          case 'getting_started':
            return (
              <GettingStarted
                content={slice.primary.content}
                items={slice.fields}
                buttonText={slice.primary.button_text || 'Get Started'}
                buttonDestination={slice.primary.destination || '/contact-us'}
              />
            );

          case 'custom_html':
            return (
              <CustomHTML content={slice.primary.content}/>
            );

          case 'form':
            if (!hasForm) {
              return (
                <CondensedContactForm
                  heading={slice.primary.heading || 'Get In Touch'}
                  buttonText={slice.primary.button_text || 'Get In Touch'}
                  handler={slice.primary.handler || 'http://go.anyclip.com/l/563282/2020-04-28/89wsx2'}
                  category={uid || 'post'}
                  thankYou={slice.primary.thank_you_text || settings.thank_you_text || 'Thank you! A member of our team will be in touch shortly.'}
                  content={slice.primary.content}
                  background={slice.primary.background}
                  variant={variant}
                />
              );
            }

            return null;

          default:
            break;
        }

        return null;
      })}
    </SliceZoneContainer>
  );
};

export default SliceZone;
